<template>
  <div class="space-main" :style="'height:' + this.$tools.mainHeight() + 'px'">
    <el-row>
      <el-col :span="17">
          <user-space-pending></user-space-pending>
      </el-col>
      <el-col :span="7">
        <el-card class="sapce-grade">
          我的积分: {{ $cookies.get("U_GRADE") }}
          <el-link
            type="primary"
            @click="showGradeDialog"
            >详情</el-link
          >
          <el-dialog title="积分详情" :visible.sync="showGrade" width="50%">
            <user-grade-detail
              :userId="gradeUserId"
              :mainHeight="this.$tools.mainHeight() - 300"
            ></user-grade-detail>
          </el-dialog>
        </el-card>

        <el-card class="sapce-clendar">
          <settings-calendar issample="Y"></settings-calendar>
        </el-card>

        <el-card
          class="sapce-top"
          :style="'height:' + (this.$tools.mainHeight() - 396) + 'px'"
        >
          <div slot="header">
            <span>积分排行(B端口业务员)</span>
          </div>
          <div v-for="(t, i) in tops" :key="i" class="sapce-top-item">
            <el-tag v-if="i == 0" size="small" type="danger">{{
              $tools.levelTag(t.grade)
            }}</el-tag>
            <el-tag v-if="i == 1" size="small" type="warning">{{
              $tools.levelTag(t.grade)
            }}</el-tag>
            <el-tag v-if="i == 2" size="small" type="success">{{
              $tools.levelTag(t.grade)
            }}</el-tag>
            <el-tag v-if="i > 2" size="small">{{
              $tools.levelTag(t.grade)
            }}</el-tag>
            <span>第{{ i + 1 }}名</span><span>{{ t.name }}</span>
            <span>{{ t.grade }}分</span>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SettingsCalendar from "./Settings-calendar.vue";
import UserGradeDetail from "./User-grade-detail.vue";
import UserSpacePending from './User-space-pending.vue';
export default {
  components: { SettingsCalendar, UserGradeDetail, UserSpacePending },
  data() {
    return {
      tops: [],
      showGrade: false,
      gradeUserId: null,
    };
  },
  methods: {
    getTops() {
      let _this = this;

      _this.$http.post(
        ["user/grade/tops"],
        [
          function (data) {
            _this.tops = data;
          },
        ],".sapce-top"
      );
    },
    showGradeDialog() {
      this.showGrade = true;
      this.gradeUserId = "self";
    }
  },
  mounted() {
    this.getTops();
  },
};
</script>

<style lang="scss">
.space-main {
  overflow: hidden;

  .el-card__body {
    padding: 10px;
  }

  .el-row {
    height: 100%;
  }

  .sapce-grade {
    height: 50px;
    margin: 10px;
  }
  .sapce-top {
    min-width: 290px;
    margin: 10px;

    .el-card__header {
      text-align: center;
    }

    .sapce-top-item {
      height: 30px;
      span {
        padding-left: 10px;
      }
    }
  }

  .sapce-clendar {
    height: 300px;
    min-width: 290px;
    margin: 10px;

    .el-calendar__body {
      padding: 0px;
    }

    .el-calendar-table:not(.is-range) td.next,
    .el-calendar-table:not(.is-range) td.prev {
      pointer-events: none;
    }

    .el-calendar-day {
      height: 26px !important;
      text-align: center;
      padding: 0px;
    }

    .el-calendar__header {
      // text-align: center;
      .el-calendar__title {
        //width: 100%;
      }
      .el-button-group > .el-button:nth-child(2) {
        display: none;
      }
    }
  }
}
</style>
